// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qsYY","colMin":"styles_colMin__1migx"};